import {SharedInitGuard} from '@shared/guards/shared-init.guard';
import { Component, OnInit, inject } from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {Storage} from '@ionic/storage-angular';
import {Store} from '@ngrx/store';
import {environment as techEnv} from '@env-tech/environment';
import {SharedLanguageService} from '@shared/services/shared-language.service';
import {Loader} from '@googlemaps/js-api-loader';
import {filter, firstValueFrom, forkJoin, Observable, take} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {SharedToastControllerService} from '@shared/services/shared-toast-controller.service';
import {TranslateService} from '@ngx-translate/core';
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {EAppType} from "@shared/models/AppType.enum";
import {SharedLoginActions} from "@shared/components/login/store/shared-login.actions-type";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

// Init the CoreEnvironmentService with the TECH app environment variables
CoreEnvironmentService.setEnvironment(techEnv);

@Component({
  selector: 'app-root',
  templateUrl: 'tech-app.component.html',
  styleUrls: ['tech-app.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class TechAppComponent implements OnInit {
  private _storage = inject(Storage);
  private _store = inject(Store);
  private _languageService = inject(SharedLanguageService);
  private _toastService = inject(SharedToastControllerService);
  private _translate = inject(TranslateService);


  public googleMapsApiLoader: Loader;

  constructor() {
    inject(SharedInitGuard);
    // Set app type
    this._store.dispatch(SharedLoginActions.setAppType({ appType: EAppType.Tech }));
    // Get the default language
    const environment = CoreEnvironmentService.getEnvironment();
    this._languageService.setDefaultLanguageByEnvironment(environment);
    // Get google maps api
    this.googleMapsApiLoader = new Loader({
      apiKey: 'AIzaSyBINOesU6mmaz46mq5tDVKlfUBCfKXnEnA',
      version: 'weekly'
    });
    this._loadGoogleMapsAPI();
  }

  async ngOnInit() {
    await this._storage.create();
    await firstValueFrom(this._store.select(SharedLoginSelectors.selectAppType).pipe(filter(appType => appType !== undefined) ));
  }

  private _loadGoogleMapsAPI(): void {
    // Init observable with library calls
    const loader$: Observable<any> = forkJoin({
      core: this.googleMapsApiLoader.importLibrary('core'),
      maps: this.googleMapsApiLoader.importLibrary('maps'),
      marker: this.googleMapsApiLoader.importLibrary('marker')
    });
    // Load or catch error
    loader$.pipe(
      take(1),
      catchError(() => this._toastService.observablePresent(
        this._translate.instant('TECH.INVENTORY.PAGES.MISSIONS.MAP.TOASTS.NO_GOOGLE_MAPS_API')
      ))
    ).subscribe(() => this._store.dispatch(TechInventoryActions.reportGoogleAPILoaded()));
  }
}
